import { render, staticRenderFns } from "./ClipboardItemCard.vue?vue&type=template&id=38aa9354&scoped=true"
import script from "./ClipboardItemCard.vue?vue&type=script&lang=js"
export * from "./ClipboardItemCard.vue?vue&type=script&lang=js"
import style0 from "./ClipboardItemCard.vue?vue&type=style&index=0&id=38aa9354&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38aa9354",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38aa9354')) {
      api.createRecord('38aa9354', component.options)
    } else {
      api.reload('38aa9354', component.options)
    }
    module.hot.accept("./ClipboardItemCard.vue?vue&type=template&id=38aa9354&scoped=true", function () {
      api.rerender('38aa9354', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/clipboard/ClipboardItemCard.vue"
export default component.exports